/**
 * Regexp to match valid email adresses.
 *     Email validity is actually not possible get a 100% right through regex,
 *     but this comes pretty close.
 */
const VALID_MAIL_RE = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //eslint-disable-line

export default email => {
  return typeof email === 'string' && email.match(VALID_MAIL_RE);
};
